import { get, post, remove } from '@/src/tools/server';
const getCheckoutSettings = (uuid, params) => {
  return get(
    `/portal/salesChannelSetting/checkoutSetting/${uuid}`,
    params || {},
  );
};
const postCheckoutSettings = (body, params) => {
  return post(
    `/portal/salesChannelSetting/checkoutSetting`,
    body,
    params || {},
  );
};

const postPromotion = (body, params) => {
  return post(
    `/portal/salesChannelSetting/checkoutSetting/promotion`,
    body,
    params || {},
  );
};

const deletePromotion = (uuid, params) => {
  return remove(
    `/portal/salesChannelSetting/checkoutSetting/promotion/${uuid}`,
    params || {},
  );
};

export {
  getCheckoutSettings,
  postPromotion,
  deletePromotion,
  postCheckoutSettings,
};
